/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BlockEdit_viewer$ref: FragmentReference;
export type BlockEdit_viewer = {|
  +id: string,
  +block: ?{|
    +id: string,
    +title: ?string,
    +active: ?boolean,
    +slug: ?string,
    +linkedArticles: ?$ReadOnlyArray<?{|
      +article: ?{|
        +id: string,
        +title: ?string,
      |},
      +title: ?string,
    |}>,
  |},
  +$fragmentRefs: ArticleSelector_viewer$ref,
  +$refType: BlockEdit_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "BlockEdit_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "id",
      "type": "ID!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ArticleSelector_viewer",
      "args": null
    },
    v0,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "block",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id",
          "type": "ID"
        }
      ],
      "concreteType": "Block",
      "plural": false,
      "selections": [
        v0,
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "active",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkedArticles",
          "storageKey": null,
          "args": null,
          "concreteType": "BlockItem",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "article",
              "storageKey": null,
              "args": null,
              "concreteType": "Article",
              "plural": false,
              "selections": [
                v0,
                v1
              ]
            },
            v1
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e2f765c7b1af1083dea6e5b637dba86a';
module.exports = node;



// WEBPACK FOOTER //
// src/components/blocks/__generated__/BlockEdit_viewer.graphql.js